import { Theme } from "@mui/material/styles";
import { RADIUS } from "../shape";

// ----------------------------------------------------------------------

export default function Input(theme: Theme) {
  const grey = theme.palette.grey as unknown as Record<string, string>;

  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            "& svg": { color: theme.palette.text.disabled },
          },
        },
        input: {
          // Regra do app: campo de texto nunca abaixo de 16px no mobile — o Safari
          // do iPhone dá zoom automático ao focar e não volta (ver ConcentrationInput).
          "&::placeholder": {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: RADIUS.control,
          // handoff: inputs são preenchidos (não transparentes) nos dois temas
          backgroundColor: theme.palette.background.paper,
          // autofill do Chrome não sobrescreve o fundo/cor do tema (quebrava no dark)
          "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
            WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.paper} inset`,
            WebkitTextFillColor: theme.palette.text.primary,
            caretColor: theme.palette.text.primary,
            borderRadius: "inherit",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.divider,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.primary.light,
          },
          "&.Mui-focused:not(.Mui-error)": {
            boxShadow: `0 0 0 4px ${theme.palette.brand.inputFocusHalo}`,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.primary.main,
            borderWidth: "1px",
          },
          "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.action.disabledBackground,
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          "&:before": {
            borderBottomColor: grey["500_56"],
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: grey["500_12"],
          "&:hover": {
            backgroundColor: grey["500_16"],
          },
          "&.Mui-focused": {
            backgroundColor: theme.palette.action.focus,
          },
          "&.Mui-disabled": {
            backgroundColor: theme.palette.action.disabledBackground,
          },
        },
        underline: {
          "&:before": {
            borderBottomColor: grey["500_56"],
          },
        },
      },
    },
  };
}
